module.exports = __webpack_public_path__ + "img/brand_logo.d9396fe5.png";